import Loadable from '../../components/loadable';

const ReportsList = Loadable({
  loader: () => import('../../pages/reports/reports_list'),
  type: 'block',
});

angular.module('gym').value('ReportsList', ReportsList);

const PerformReportBulkActionsDrawer = Loadable({
  loader: () => import('../../pages/reports/perform_report_bulk_actions_drawer'),
  type: 'drawer',
});

angular.module('gym').value('PerformReportBulkActionsDrawer', PerformReportBulkActionsDrawer);
